var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":_vm.toggleFullScreen}},[_c('svg-icon',{attrs:{"icon-class":_vm.iconClass,"class-name":"screenfull"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }